import { IdFilter, StringFilter } from "react3l-advanced-filters";
import { ModelFilter } from "react3l-common";
import { Field, ObjectField } from "react3l-decorators";

export class EmailRemindConfigFilter extends ModelFilter {
  @ObjectField(IdFilter)
  public id?: IdFilter = new IdFilter();
  @ObjectField(StringFilter)
  public code?: StringFilter = new StringFilter();
  @ObjectField(StringFilter)
  public name?: StringFilter = new StringFilter();
  @ObjectField(IdFilter)
  public applyFunctionId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public organizationId?: IdFilter = new IdFilter();
  @ObjectField(IdFilter)
  public statusId?: IdFilter = new IdFilter();
  @ObjectField(StringFilter)
  public description?: StringFilter = new StringFilter();
  @Field(String)
  public search?: string;
}
